/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import checkWhiteList from './helper/WhiteList';
// whitelist flag is used to enable specific users
// customer service whitelist is in a different spot but works the same
// hide button flag takes absolute precedence: if true display none except for when the iframe is externally triggered or persisted
// limit flag will hide but allows for page type and url overrides
export const CHAT_EXPERIENCES = {
    customerService: {
        route: '/chat/flora',
        pageTypesFlag: 'chat-button-page-type-whitelist',
        urlsFlag: 'chat-button-url-whitelist-array',
        limitFlag: 'limit-chat-to-customer-service-page',
        hideButtonFlag: 'customer-service-chat-hide-button',
    },
    salesIntent: {
        route: '/chat/sales_intent',
        enabledFlag: 'decagon-test-sales-intent-enabled',
        whitelistFlag: 'sales-intent-chat-whitelist',
        pageTypesFlag: 'sales-intent-chat-button-page-type-whitelist',
        urlsFlag: 'sales-intent-chat-button-url-whitelist-array',
        limitFlag: 'sales-intent-chat-limit-to-whitelist',
        hideButtonFlag: 'sales-intent-chat-hide-button',
    },
    gemini: {
        route: '/chat/ggsa',
        enabledFlag: 'gemini-chat-enabled',
        whitelistFlag: 'gemini-chat-whitelist',
        pageTypesFlag: 'gemini-chat-button-page-type-whitelist',
        urlsFlag: 'gemini-chat-button-url-whitelist-array',
        limitFlag: 'gemini-chat-limit-to-whitelist',
        hideButtonFlag: 'gemini-chat-hide-button',
    },
};

export const isExperienceEnabled = (id, flags, customerServiceEnabled = true) => {
    const config = CHAT_EXPERIENCES[id];
    if (!config) return false;
    if (id === 'customerService') return customerServiceEnabled;
    return Boolean(flags[config.enabledFlag] || (flags[config.whitelistFlag] && checkWhiteList(flags[config.whitelistFlag])));
};

const normalizePath = (path = '/') => path.replace(/\/+$/, '') || '/';

// Page restrictions and hide-button flags only control the floating launcher.
// Explicit entry points may open an enabled experience on any page.
export const isLauncherVisible = (id, flags, pathname, pageType) => {
    const config = CHAT_EXPERIENCES[id];
    if (!config || flags[config.hideButtonFlag]) return false;
    if (!flags[config.limitFlag]) return true;
    const types = flags[config.pageTypesFlag]?.types;
    const urls = flags[config.urlsFlag]?.urls;
    return (Array.isArray(types) && types.includes(pageType)) || (Array.isArray(urls) && urls.some((url) => {
        if (typeof url !== 'string') return false;
        try {
            return normalizePath(new URL(url, 'https://chat.invalid').pathname) === normalizePath(pathname);
        } catch {
            return false;
        }
    })) || false;
};
